// TableSearch.jsx
import React from 'react'
import useTranslations from "../../../hooks/useTranslations";
import useUserLanguage from "../../../hooks/useUserLanguage";

const TableSearch = ({
  table,
  globalFilter,
  setGlobalFilter
}) => {
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  return (
    <div className='row gy-2'>
      <div className='col-sm-12 col-md-6 ps-0 m-0 pb-10'>
        <div className='dataTables_length d-flex justify-content-md-start justify-content-center'>
          <label className='d-flex align-items-center gap-1'>
           
            {getText("TABLE_SEARCH_PAGE_SIZE_LABEL")}

            <select
              className='form-select form-select-sm w-auto pe-4'
              value={table.getState().pagination.pageSize}
              onChange={e => {
                table.setPageSize(Number(e.target.value))
              }}
            >
              {[10, 25, 50, 100].map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  {pageSize}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>

      <div className='col-sm-12 col-md-6 ps-0 m-0 pb-10'>
        <div className='dataTables_filter d-flex justify-content-md-end justify-content-center'>
          <label className='d-inline-flex align-items-center gap-2'>
            
            {getText("TABLE_SEARCH_FILTER_LABEL")}

            <input
              type="text"
              value={globalFilter ?? ""}
              onChange={(e) => setGlobalFilter(e.target.value)}
              placeholder={getText("TABLE_SEARCH_FILTER_PLACEHOLDER")}
              className="form-control form-control-sm"
            />
          </label>
        </div>
      </div>
    </div>
  )
}

export default TableSearch
